/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { capitalize } from "@ember/string";
import Component from "@glimmer/component";
import type Patient from "parog-web/models/patient";
import { modifier } from "ember-modifier";
import type { Signature as BaseCancerFormSignature } from "../../base-cancer-form";
import BaseCancerForm from "../../base-cancer-form";

export interface Signature {
  Args: {
    BasicRadioGroup?: unknown;
    form: BaseCancerFormSignature["Args"]["form"];
    patient: Patient;
  };
}

export default class MedicalHistoryFormBreastCancerDiagnosticFieldsComponent extends Component<Signature> {
  BaseCancerForm = BaseCancerForm;
  capitalize = capitalize;
  disableMetastaticField = modifier(function (e: HTMLElement): void {
    e
      .querySelector('.ui.dropdown[data-test-dropdown="tnmClassification.m"]')
      ?.classList.add("disabled");
  });
}
